// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3iDHX","overflowing":"ReadFullNote_overflowing__1KZ6S"};